define(["require", "exports", "./analytics"], function (require, exports, analytics_1) {
    "use strict";
    exports.__esModule = true;
    function trackClick(e) {
        var src = $(e.currentTarget);
        var data = src.data('track-as');
        try {
            analytics_1["default"].apply(null, data);
        }
        catch (err) {
            analytics_1["default"]('exception', 'trackAs', JSON.stringify(data));
        }
    }
    exports.trackClick = trackClick;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/track.js
// module id = 74
// module chunks = 0